import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card } from '@/components/ui/card';
import { toast } from 'sonner';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setEmailSent(true);
      toast.success('Correo de recuperación enviado');
    } catch (error) {
      const errorMsg = error.response?.data?.detail;
      if (Array.isArray(errorMsg)) {
        toast.error(errorMsg.map(e => e.msg).join(', '));
      } else {
        toast.error(errorMsg || 'Error al enviar correo de recuperación');
      }
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#F9F8F6' }}>
        <Card className="w-full max-w-md p-8 text-center">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>
          <h1 className="text-2xl font-bold mb-2" style={{ color: '#2D3748' }}>
            Correo Enviado
          </h1>
          <p className="text-gray-600 mb-6">
            Hemos enviado un enlace de recuperación a <strong>{email}</strong>.
            <br /><br />
            Por favor, revisa tu bandeja de entrada y sigue las instrucciones para restablecer tu contraseña.
          </p>
          <Link to="/auth">
            <Button className="w-full" style={{ backgroundColor: '#5A7D6C' }}>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Volver al Login
            </Button>
          </Link>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#F9F8F6' }}>
      <Card className="w-full max-w-md p-8">
        <div className="text-center mb-6">
          <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
            <Mail className="h-8 w-8" style={{ color: '#5A7D6C' }} />
          </div>
          <h1 className="text-2xl font-bold mb-2" style={{ color: '#2D3748', fontFamily: 'Manrope' }}>
            ¿Olvidó su contraseña?
          </h1>
          <p className="text-sm text-gray-600">
            Ingrese su correo electrónico y le enviaremos un enlace para restablecer su contraseña
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email">Correo Electrónico</Label>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="su-email@ejemplo.com"
              required
              className="mt-1"
            />
          </div>

          <Button
            type="submit"
            className="w-full"
            disabled={loading}
            style={{ backgroundColor: '#5A7D6C' }}
          >
            {loading ? 'Enviando...' : 'Enviar Enlace de Recuperación'}
          </Button>
        </form>

        <div className="mt-6 text-center">
          <Link 
            to="/auth" 
            className="text-sm hover:underline flex items-center justify-center gap-2"
            style={{ color: '#5A7D6C' }}
          >
            <ArrowLeft className="h-4 w-4" />
            Volver al Login
          </Link>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;
